import React from 'react';
import styled from '@benzinga/themetron';
import { Spinner, Button, FeedButton } from '@benzinga/core-ui';

export interface LoadMoreElementProps {
  didFail: boolean;
  didLoad: boolean;
  isInfinite: boolean;
  isLoading: boolean;
  onLoadMore: (analyticsEvents?: boolean) => Promise<void>;
  loadMoreStyle?: 'text' | 'button';
  loadMoreElement?: ((loading: boolean, loadMoreItems: () => void) => React.ReactElement) | undefined;
}

export const LoadMoreElement: React.FC<LoadMoreElementProps> = ({
  didFail,
  didLoad,
  isInfinite,
  isLoading,
  loadMoreElement,
  loadMoreStyle,
  onLoadMore,
}) => {
  if (loadMoreElement) {
    return loadMoreElement(isLoading, onLoadMore);
  } else if (isLoading) {
    return (
      <StyledLoadMoreElement className="load-more-element-spinner">
        <Spinner />
      </StyledLoadMoreElement>
    );
  } else if (isInfinite && !didFail) {
    return (
      <StyledLoadMoreElement className="feed-more-wrapper">
        {didLoad ? <FeedButton loadMore={() => onLoadMore()} /> : null}
      </StyledLoadMoreElement>
    );
  } else {
    return (
      <StyledLoadMoreElement className="load-more-button" onClick={() => onLoadMore()} role="button" tabIndex={0}>
        {loadMoreStyle === 'button' ? <Button variant="primary">Load more</Button> : 'Load more'}
      </StyledLoadMoreElement>
    );
  }
};

const StyledLoadMoreElement = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 5px 0;
  font-weight: bold;
  color: ${({ theme }) => theme.colorPalette.blue500};
  width: 100%;
  padding: 10px 0;
  cursor: pointer;

  &.feed-more-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
`;
